import React from 'react';
import cn from 'classnames';
import { PORTFOLIO_MONITOR_PAGE_TITLE } from '@/creditflowresearch/ui/components/portfolioMonitor/constants';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import CheckUserAccess from '@/creditflowresearch/ui/common/components/CheckUserAccess';
import MissingSomethingModalButton from '@/creditflowresearch/ui/common/components/MissingSomethingModalButton';
import PortfolioMonitor from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioMonitor';
import getPortfolioMonitorOverlay from '@/creditflowresearch/ui/components/portfolioMonitor/getPortfolioMonitorOverlay';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import ProductPageHeader from '@/creditflowresearch/ui/common/components/templates/ProductPageHeader/ProductPageHeader';

import spacesStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';
import productColors from '@/creditflowresearch/ui/common/styles/productColors';

const PortfolioMonitorPage = (props) => {
  const { checkAccessByUserPlan } = useUserPlanContext();
  return (
    <div>
      <ProductPageHeader
        title={ PORTFOLIO_MONITOR_PAGE_TITLE }
        withoutProductTitle
        accessConditions={ [{ checks: [checkAccessByUserPlan(UserPlanType.PRO)] }] }
        blockingAccessConditions={ [{ checks: [checkAccessByUserPlan(UserPlanType.STARTER)] }] }
        panelBackground={ productColors.gradientProductAbs }
      />
      <CheckUserAccess
        conditions={ [{
          checks: [checkAccessByUserPlan(UserPlanType.PRO)],
          fallback: getPortfolioMonitorOverlay(false),
        }] }
      >
        <PortfolioMonitor { ...props } />
      </CheckUserAccess>
      <MissingSomethingModalButton className={ cn(spacesStyles.ptxl, spacesStyles.pbxl) } />
    </div>
  );
};

export default PortfolioMonitorPage;
